import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose, withState, withHandlers, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
// import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import HomeIcon from '@material-ui/icons/Home';
import Person from '@material-ui/icons/Person';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { signOut } from '../auth/Auth';
import { nameSystem } from '../constants/TextSystem';
import { getTextBySystem as gts } from '../utils';

const styles = {
  grow: {
    flexGrow: 1,
    textAlign: 'center'
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  menuIcons: {
    width: 32,
    height: 32
  },
  homeIcons: {
    width: 32,
    height: 32
  },
  popper: {
    zIndex: 100
  },
  homeButton: {
    position: 'absolute',
    top: 0,
    left: 0
  },
  headerShop: {
    // padding: '0 40px 0 56px',
    padding: '0 0 0 49px',
    justifyContent: 'center',
    minHeight: 56
  },
  ttlShop: {
    fontSize: 18,
    fontWeight: 'bold'
  },
  headerAdmin: {
    justifyContent: 'space-between'
  },
  logoHeader: {
    height: '36px',
    marginLeft: '-44px',
    marginTop: '5px'
  },
  fukuokaHeader: {
    marginLeft: '-44px',
    textAlign: 'center',
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '23px'
  }
};

const enhance = compose(
  connect(state => ({
    account: state.accounts.account
  })),
  withState('open', 'setOpen', false),
  withHandlers({
    openToggleMenu: props => {
      props.setOpen(prevOpen => !prevOpen);
    },
    closeToggleMenu: props => {
      props.setOpen(false);
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    async componentDidMount() {
      // let addPopupJs = true;
      // const url = 'https://gochimeshi.karakuri.ai/api/chats/popup.js';
      // const scripts = document.getElementsByTagName('script');
      // // eslint-disable-next-line no-plusplus
      // for (let i = scripts.length; i--; ) {
      //   if (scripts[i].src === url) {
      //     addPopupJs = false;
      //   }
      // }
      // const script = document.createElement('script');
      // script.src = url;
      // script.async = true;
      // if (addPopupJs) {
      //   document.body.appendChild(script);
      // }
    }
  })
);

const Header = enhance(
  ({
    classes,
    account,
    onMenuClick,
    open,
    openToggleMenu,
    closeToggleMenu,
    handleRedirect
  }) => {
    const anchorRef = React.useRef(null);

    const onPressSignOut = async () => {
      signOut();
      handleRedirect('/');
    };
    const onPressEmailChange = async () => {
      handleRedirect('/email_change');
    };
    const onPressPasswordChange = async () => {
      handleRedirect('/passowrd_change');
    };

    const onHomeBackClick = async () => {
      handleRedirect('/home');
    };

    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;
    const educateSystem =
      typeof account !== 'undefined' && account.educateSystem;
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const readFlag = account && account.manageNoticeRead;
    console.log('isShop', isShop);
    console.log('isReleased', isReleased);

    useEffect(() => {
      document.title = gts('ごちめし', educateSystem);
      const link = document.querySelector("link[rel~='icon']");
      if (isFukuoka && educateSystem === nameSystem.fukuoka) {
        link.href = `${process.env.PUBLIC_URL}/images/logo_fukuoka_icon.png`;
      } else if (isFukuoka && educateSystem === nameSystem.suita) {
        link.href = `${process.env.PUBLIC_URL}/images/logo_suita_icon.ico`;
      } else if (isFukuoka && educateSystem === nameSystem.nishiwaki) {
        link.href = `${process.env.PUBLIC_URL}/images/logo_nishiwaki.ico`;
      } else {
        link.href = `favicon.ico`;
      }
    }, [isFukuoka, educateSystem]);

    return (
      <AppBar position="static">
        <Toolbar className={isShop ? classes.headerShop : classes.headerAdmin}>
          {/* <Toolbar className={classes.headerAdmin}> */}
          {!isShop && (!isShop || isReleased) && (
            // {(!isShop || isReleased) && (
            <IconButton
              color="inherit"
              className={classes.menuButton}
              onClick={onMenuClick}
            >
              <Badge color="secondary" variant="dot" invisible={readFlag}>
                <MenuIcon className={classes.menuIcons} />
              </Badge>
            </IconButton>
          )}
          {isShop && (
            <IconButton
              color="inherit"
              className={classes.homeButton}
              onClick={onHomeBackClick}
            >
              <HomeIcon className={classes.homeIcons} />
            </IconButton>
          )}
          {isFukuoka ? (
            <div className={classes.fukuokaHeader}>
              {gts('福岡市子ども習い事応援事業', educateSystem)}
              <br />
              管理システム
            </div>
          ) : (
            <img
              alt="logo"
              src="/images/logo-manage-shop-gcms.png"
              className={classes.logoHeader}
            />
          )}

          {!isShop && (!isShop || isReleased) && (
            <>
              <IconButton
                ref={anchorRef}
                color="inherit"
                onClick={openToggleMenu}
              >
                <Person className={classes.menuIcons} />
              </IconButton>
              <Popper
                open={open}
                anchorEl={anchorRef.current}
                className={classes.popper}
              >
                <Paper>
                  <ClickAwayListener onClickAway={closeToggleMenu}>
                    <List>
                      <ListItem button onClick={onPressEmailChange}>
                        <ListItemText>メールアドレス変更</ListItemText>
                      </ListItem>
                      <ListItem button onClick={onPressPasswordChange}>
                        <ListItemText>パスワード変更</ListItemText>
                      </ListItem>
                      <ListItem button onClick={onPressSignOut}>
                        <ListItemText>ログアウト</ListItemText>
                      </ListItem>
                    </List>
                  </ClickAwayListener>
                </Paper>
              </Popper>
            </>
          )}
        </Toolbar>
      </AppBar>
    );
  }
);

export default withRouter(withStyles(styles)(Header));
